export default {
    name: "home",
    inject: ['$axios'],
    data() {
        return {
            tabbar_active: 'order',
            shopConfig: {
                is_seize:0
            },
            loginType: 0,//登录类型 0-配送员 1-水站
        }
    },
    methods: {
        onChange(name) {
            //切换页面
            console.log(name)

            //获取当前GPS

        },

        //获取店铺设置
        getShopConfig() {
            let that = this;

            that.$axios.get('/api/v1/shop/config',{

            }).then(res => {
                if (res.code == 200) {
                    that.shopConfig = res.data;
                }
            });
        },
    },
    mounted() {
        //登录类型
        let loginType = localStorage.getItem('login_type');
        if(loginType * 1) {
            //经销商
            this.loginType = 1;
            this.tabbar_active = 'person';

            //跳转到经销商
            this.$router.push({
                path: '/home/person'
            })

        } else {
            //配送员
            this.loginType = 0;


        }


    },
    activated() {
        //获取店铺设置
        this.getShopConfig();
    }
}